import React, { useEffect, useState } from "react";
import { Box, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";

import { useDispatch, useSelector } from "react-redux";
import AppConfig, { CLIENT_TYPE, PART_TYPE_CLIENT } from "config/AppConfig";

import {
  updatePersonalInfo,
  updateBillingInfo,
  updateVerification,
  updateAgreement,
  createClient,
  fetchClientDetail
} from "store/slices/client";
import { showToast } from "store/slices/toast";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
import GeneralInfoForm from "views/User/OnBoard/Client/GeneralInformationForm";
import BillingHospitalForm from "views/User/OnBoard/Client/BillingHospitalForm";
import VerificationForm from "views/User/OnBoard/Client/VerificationForm";
import BillingParticipantForm from "views/User/OnBoard/Client/BillingParticipantForm";
import ProgressOnboard from "views/User/OnBoard/ProgressOnboard";
import AppUtil from "utilities/AppUtil";
import AppColor from "utilities/AppColor";
import UserHospitalTable from "./UserHospitalTable";
import UserCoordinatorTable from "./UserCoordinatorTable";
import CoordinatorParticipantTable from "./CoordinatorParticipantTable";
// import AppButton from "components/CustomButtons/AppButton";
// import AdminFeedbackForm from "views/User/OnBoard/AdminFeedbackForm";
// import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import AgreementForm from "views/User/OnBoard/Client/AgreementForm";
import { getAuthInfo } from "store/slices/auth";
import { fetchSuperFunds } from "store/slices/worker";
import { ACCOUNTING_TYPE } from "config/AppConfig";
// import { useMedia } from "react-use";
import ScrollableTabs from "components/CustomTabs/AppTabsScroll";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { reduceDeActivateClient } from "store/slices/client";
import { reduceActivateClient } from "store/slices/client";
import AppButton from "components/CustomButtons/AppButton";

const { APPROVAL_STATUS, SYSTEM_STATUS } = AppConfig;

const hospitalOnboard = [
  { label: 'title.generalInformation', checked: false, code: PART_TYPE_CLIENT.GENERAL_INFO },
  { label: 'title.billingInformation', checked: false, code: PART_TYPE_CLIENT.BILLING_INFO },
  { label: 'title.agreement', code: PART_TYPE_CLIENT.AGREEMENT, checked: false, isAgreement: true }
];
const coordinatorOnboard = [
  { label: 'title.generalInformation', checked: false, code: PART_TYPE_CLIENT.GENERAL_INFO },
  { label: 'title.agreement', code: PART_TYPE_CLIENT.AGREEMENT, checked: false, isAgreement: true }
];
const participantOnboard = [
  { label: 'title.generalInformation', checked: false, code: PART_TYPE_CLIENT.GENERAL_INFO },
  { label: 'title.carePlan', checked: false, code: PART_TYPE_CLIENT.VERIFICATION },
  { label: 'title.billingInformation', checked: false, code: PART_TYPE_CLIENT.BILLING_INFO },
  { label: 'title.agreement', code: PART_TYPE_CLIENT.AGREEMENT, checked: false, isAgreement: true }
];

const styles = makeStyles(() => ({
  container: {
    padding: "1rem",
  },
  wrapper: {
    padding: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperLeft: {
    padding: '0 1rem 1rem 1rem',
    marginRight: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperBottom: {
    padding: '0 1rem 1rem 1rem',
    marginBottom: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperRight: {
    padding: '1rem',
    border: '1px solid #d2d2d2'
  },
  boxActive: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0.5rem",
  },
  boxActivate: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "2rem 0.5rem",
  },
  title: {
    display: 'flex',
    marginBottom: '1rem',
    '& h5': {
      color: AppColor.mainColor,
    }
  },
}));

const ClientDetail = () => {
  const { t } = useTranslation();
  // const below768 = useMedia('(max-width: 767.2px)');
  const isMobile = AppUtil.mobileAndTabletCheck();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = styles();
  const { id } = useParams();
  const userInfo = useSelector(getAuthInfo);

  const { accountingType } = userInfo;
  const type = CLIENT_TYPE.PARTICIPANT;

  const [loading, setLoading] = useState(false);
  const [progressPercent, setProgressPercent] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isHospital, setIsHospital] = useState(false);
  const [isCoordinator, setIsCoordinator] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [clientType, setClientType] = useState(type);
  const [clientDetail, setClientDetail] = useState({});
  const [isMultipleUser, setIsMultipleUser] = useState(false);
  const [backStep, setBackStep] = useState(false);
  const [showConfirmDeActivate, setShowConfirmDeActivate] = useState(false);
  const [showConfirmActivate, setShowConfirmActivate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    client = {}
  } = clientDetail;

  const {
    id: clientId,
    approvalStatus,
  } = client;

  const { companyId } = userInfo;

  useEffect(() => {
    if (window.location.href.includes('create')) {
      setIsCreate(true);
    } else {
      setIsCreate(false);
    }
    initProgressByClientType(type);
  }, []);
  useEffect(() => {
    if (id) {
      loadClientDetail();
      // !isCreate && loadClientFeedback();
    }
  }, [id]);


  useEffect(() => {
    if (isCreate) {
      if (accountingType === ACCOUNTING_TYPE.XERO) {
        dispatch(fetchSuperFunds()).then(({ payload }) => {
          if (!payload) {
            history.push('/admin/participants');
          }
        })
      }
    }
  }, [isCreate]);

  const loadClientDetail = async () => {
    const result = await dispatch(fetchClientDetail({ clientId: id, companyId: companyId }));
    if (result.payload) {
      const { client: clientInfo } = result.payload;
      setClientType(clientInfo.clientType);
      initProgressByClientType(clientInfo.clientType);
      setClientDetail({ ...result.payload });
    }
  };

  const submitGeneralInfo = async (form) => {
    const { firstName, lastName, emailClient, email, ...rest } = form;
    let params;
    setLoading(true);
    let result;
    if (clientId) {
      params = {
        clientUser: {
          firstName: firstName,
          lastName: lastName,
          personalInfoEmail: email.trim()
        },
        clientContactInfo: {
          ...rest,
          emailClient: emailClient.trim()
        },
        clientId: clientId,
        companyId: companyId
      }
      if (isMultipleUser) {
        params.clientUser = null;
      }
      result = await dispatch(updatePersonalInfo(params));
    } else {
      params = {
        ...form,
        emailClient: emailClient.trim(),
        emailClientUser: email.trim(),
        clientType,
        companyId: companyId
      }
      delete params.email;
      result = await dispatch(createClient(params));
    }
    setLoading(false);
    if (result.payload) {
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(0);
      if (isCreate) {
        history.push(`/admin/participants/create/${result.payload.id}`);
      } else {
        loadClientDetail();
      }
    }
  };
  const submitBillingHospital = async (form) => {
    setLoading(true);
    const result = await dispatch(updateBillingInfo({ ...form, companyId }));
    setLoading(false);
    if (result.payload) {
      loadClientDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(1);
    }
  };
  const submitVerification = async (form) => {
    setLoading(true);
    const result = await dispatch(updateVerification({ ...form, companyId }));
    setLoading(false);
    if (result.payload) {
      loadClientDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(1);
    }
  };
  const submitBillingParticipant = async (form) => {
    setLoading(true);
    const result = await dispatch(updateBillingInfo({ ...form, companyId }));
    setLoading(false);
    if (result.payload) {
      loadClientDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(2);
    }
  };
  const submitAgreement = async (form) => {
    const unCheckForm = progress.find(item => !item.checked && !item.isAgreement);

    if (unCheckForm) {
      dispatch(showToast({
        type: "warning",
        message: t(`toast.warning.needCompleteAllForm`)
      }));
      return;
    }

    setLoading(true);
    const result = await dispatch(updateAgreement({
      ...form,
      id: id,
      companyId: companyId
    }));
    setLoading(false);
    if (result.payload) {
      loadClientDetail();
      AppUtil.scrollToTopById("main-panel");
    }
  };

  const handleCheckProgress = (index) => {
    if ((index + 1) === progress.length) {
      return;
    }
    setCurrentStep(index + 1);
  };

  const handleProgressStatus = (index, isCheck) => {
    let clone;
    clone = [...progress];
    if (clone[index]) {
      clone[index].checked = isCheck;
      setProgress(clone);

      if (isCreate && isCheck && clone.filter(item => item.checked === false)[0]) {
        handleCheckProgress(index);
      }
    }

    let percent = clone.filter(item => item.checked);
    const numberFormComplete = percent.length;
    const numberForm = clone.length;
    setProgressPercent(parseInt((numberFormComplete / numberForm * 100), 10));
    if (numberFormComplete === numberForm) {
      // setIsValidAll(true);
      if (isCreate) {
        setTimeout(() => {
          history.push(`/admin/participants`);
        }, 1000);
      }
    }
  };
  const handleBackStep = (index) => {
    // loadClientDetail();
    if ((approvalStatus === APPROVAL_STATUS.PENDING || isCreate) && index > currentStep) {
      if (progress[currentStep].checked) {
        for (let i = currentStep; i <= index; i++) {
          if (!progress[i].checked) {
            setCurrentStep(i);
            return;
          }
        }
        setCurrentStep(index);
      } else {
        dispatch(showToast({
          type: "warning",
          message: t(`toast.warning.needCompleteForm`),
        }));
        isMobile && setCurrentStep(currentStep);
        isMobile && setBackStep(true)
      }
      return;
    }
    setCurrentStep(index);
  };

  const initProgressByClientType = (type) => {
    switch (type) {
      case CLIENT_TYPE.MULTIPLE_USER_HOSPITAL:
      case CLIENT_TYPE.SINGLE_USER_HOSPITAL:
        setProgress(hospitalOnboard.map(item => {
          item.checked = false;
          return item;
        }));
        setIsHospital(true);
        break;
      case CLIENT_TYPE.MULTIPLE_USER_COORDINATOR:
      case CLIENT_TYPE.SINGLE_USER_COORDINATOR:
        setProgress(coordinatorOnboard.map(item => {
          item.checked = false;
          return item;
        }));
        setIsCoordinator(true);
        break;
      case CLIENT_TYPE.PARTICIPANT:
        setProgress(participantOnboard.map(item => {
          item.checked = false;
          return item;
        }));
        setIsParticipant(true);
        break;
      default:
        break;
    }

    if (type === CLIENT_TYPE.MULTIPLE_USER_HOSPITAL || type === CLIENT_TYPE.MULTIPLE_USER_COORDINATOR) {
      setIsMultipleUser(true);
    } else {
      setIsMultipleUser(false);
    }
  };

  const handleActivateClient = async () => {
    const result = await dispatch(reduceActivateClient(clientId));
    if (result.payload) {
      loadClientDetail();
    }
    setShowConfirmActivate(false);
    setIsSubmitting(false);
    if (isCreate) {
      history.push('/admin/company');
    }
  };

  const handleDeActivateClient = async () => {
    const result = await dispatch(reduceDeActivateClient(clientId));
    if (result.payload) {
      loadClientDetail();
    }
    setIsSubmitting(false);
    setShowConfirmDeActivate(false);
  }

  const tabs = [
    {
      id: 1,
      title: t('title.generalInformation'),
      component: <GeneralInfoForm
        onSubmit={submitGeneralInfo}
        changeProgressStatus={handleProgressStatus}
        display={currentStep === 0}
        isCreate={isCreate}
        hidePersonalInfo={!isCreate && isMultipleUser}
        clientDetail={clientDetail}
        hideLeftControl={true}
        type={type}
      />
    },
    {
      id: 2,
      title: t('title.verification'),
      component: <VerificationForm
        onSubmit={submitVerification}
        changeProgressStatus={handleProgressStatus}
        clientDetail={clientDetail}
        display={currentStep === 1 && isParticipant}
        hideLeftControl={true}
        type={type}
      />
    },
    {
      id: 3,
      title: t('title.billingInformation'),
      component: <BillingParticipantForm
        onSubmit={submitBillingParticipant}
        changeProgressStatus={handleProgressStatus}
        clientDetail={clientDetail}
        display={currentStep === 2 && isParticipant}
        hideLeftControl={true}
        type={type}
      />
    },
    {
      id: 4,
      title: t('title.agreement'),
      component: <AgreementForm
        onSubmit={submitAgreement}
        loadClientDetail={loadClientDetail}
        changeProgressStatus={handleProgressStatus}
        clientDetail={clientDetail}
        display={
          (currentStep === 2 && isHospital) ||
          (currentStep === 1 && isCoordinator) ||
          (currentStep === 3 && isParticipant)
        }
        hideLeftControl={true}
      />
    }
  ]
  console.log('client', client);
  return (
    <React.Fragment>
      <Box>
        <Box className={classes.title}>
          <Typography variant="h5">
            {`${isCreate ? t("label.create") : t("label.edit")}
            - ${isHospital ? (clientType === CLIENT_TYPE.MULTIPLE_USER_HOSPITAL)
                ? t('client_type.MULTIPLE_USER_HOSPITAL')
                : t('client_type.SINGLE_USER_HOSPITAL') : ''}
              ${isCoordinator
                ? (clientType === CLIENT_TYPE.MULTIPLE_USER_COORDINATOR)
                  ? t('client_type.MULTIPLE_USER_COORDINATOR')
                  : t('client_type.SINGLE_USER_COORDINATOR')
                : ''}${isParticipant ? t("label.participant") : ''}`}
          </Typography>
        </Box>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={isMobile ? 12 : 6} md={8}>
            {isMobile ?
              <React.Fragment>
                {progress && progress.length > 0 && (
                  <ScrollableTabs
                    swipeable={false}
                    activeTab={currentStep}
                    // onChangeTab={setCurrentStep}
                    backStep={backStep}
                    setBackStep={setBackStep}
                    handleCheckProgress={handleBackStep}
                    tabs={tabs.map(item => {
                      const {
                        title,
                        component: Component
                      } = item;
                      return {
                        tabLabel: title,
                        tabContent: Component
                      }
                    })}
                  />
                )}

              </React.Fragment>
              :

              <Paper className={classes.wrapperLeft}>
                {
                  progress && progress.length > 0 && (
                    <React.Fragment>
                      <GeneralInfoForm
                        onSubmit={submitGeneralInfo}
                        changeProgressStatus={handleProgressStatus}
                        display={currentStep === 0}
                        isCreate={isCreate}
                        hidePersonalInfo={!isCreate && isMultipleUser}
                        clientDetail={clientDetail}
                        hideLeftControl={true}
                        type={type}
                      />
                      {
                        isHospital && (
                          <BillingHospitalForm
                            onSubmit={submitBillingHospital}
                            changeProgressStatus={handleProgressStatus}
                            clientDetail={clientDetail}
                            display={currentStep === 1 && isHospital}
                            hideLeftControl={true}
                            type={type}
                          />
                        )
                      }
                      {
                        isParticipant && (
                          <React.Fragment>
                            <VerificationForm
                              onSubmit={submitVerification}
                              changeProgressStatus={handleProgressStatus}
                              clientDetail={clientDetail}
                              display={currentStep === 1 && isParticipant}
                              hideLeftControl={true}
                              type={type}
                            />
                            <BillingParticipantForm
                              onSubmit={submitBillingParticipant}
                              changeProgressStatus={handleProgressStatus}
                              clientDetail={clientDetail}
                              display={currentStep === 2 && isParticipant}
                              hideLeftControl={true}
                              type={type}
                            />
                          </React.Fragment>
                        )
                      }
                      <AgreementForm
                        onSubmit={submitAgreement}
                        loadClientDetail={loadClientDetail}
                        changeProgressStatus={handleProgressStatus}
                        clientDetail={clientDetail}
                        display={
                          (currentStep === 2 && isHospital) ||
                          (currentStep === 1 && isCoordinator) ||
                          (currentStep === 3 && isParticipant)
                        }
                        hideLeftControl={true}
                      />
                    </React.Fragment>
                  )
                }
              </Paper>}

          </Grid>
          {!isMobile && <Grid item xs={12} sm={6} md={4}>
            <Paper className={classes.wrapperRight}>
              <ProgressOnboard
                step={currentStep}
                value={progressPercent}
                progress={progress}
                handleBackStep={handleBackStep}
                hideCircle={!isCreate}
              />
            </Paper>
            {
              client && client.approvalStatus === APPROVAL_STATUS.ACTIVE && (
                <Box className={classes.boxActive}>
                  {
                    client.status === SYSTEM_STATUS.DEACTIVATE &&
                    <AppButton
                      label={`${t("button.reactivate")}`}
                      onClick={() => setShowConfirmActivate(true)}
                      rounder
                      buttonColor={AppColor.mainColor}
                      isLoading={isSubmitting}
                      disabled={isSubmitting}
                      titleTooltip={t("text.activate_client")}
                    />
                  }
                  {
                    client.status === SYSTEM_STATUS.ACTIVE &&
                    <AppButton
                      label={`${t("button.deactivate")}`}
                      onClick={() => setShowConfirmDeActivate(true)}
                      rounder
                      buttonColor={AppColor.red}
                      isLoading={isSubmitting}
                      disabled={isSubmitting}
                      style={{ marginRight: '1rem' }}
                      titleTooltip={t("text.deactivate_client")}

                    />
                  }
                </Box>
              )
            }

          </Grid>}
          {
            !isCreate && (
              <Grid item xs={12} sm={12} md={12} className="mt-5">
                {
                  isHospital && isMultipleUser && (
                    <Paper className="mt-5 p-3">
                      <UserHospitalTable clientId={id} companyId={companyId} />
                    </Paper>
                  )
                }
                {
                  isCoordinator && (
                    <Paper className="mt-5 p-3">
                      <CoordinatorParticipantTable clientId={id} companyId={companyId} />
                    </Paper>
                  )
                }
                {
                  isCoordinator && isMultipleUser && (
                    <Paper className="mt-5 p-3">
                      <UserCoordinatorTable clientId={id} companyId={companyId} />
                    </Paper>
                  )
                }
              </Grid>
            )
          }
        </Grid>
        <AppDialog
          open={loading}
          onClose={() => setLoading(false)}
          noTitle
          noCloseButton
          disableEscapeKeyDown
        >
          <Box my={3}>
            <ComponentLoading />
          </Box>
        </AppDialog>
        <AppConfirmDialog
          open={showConfirmActivate}
          onConfirm={() => handleActivateClient()}
          onClose={() => setShowConfirmActivate(false)}
          title={t("title.reactiveClient")}
          content={t("text.activate_client")}
        />
        <AppConfirmDialog
          open={showConfirmDeActivate}
          onConfirm={() => handleDeActivateClient()}
          onClose={() => setShowConfirmDeActivate(false)}
          title={t("title.de_activate_client")}
          content={t("text.de_activate_client")}
        />
      </Box>
    </React.Fragment>
  );
}
ClientDetail.propTypes = {
  authInfo: PropTypes.object
};

export default ClientDetail;